export default __webpack_public_path__ + "static/media/who_we_are.26517e7a.png";